/**
 * NoMatchFound Component
 */

import {
  getBusinessEuropeanPhoneNumber, getBusinessMainPhoneNumber, getBusinessOpeningHours,
} from '../../../../redux/selectors/staticData';
import Olark from '../../../../utils/olark';
import { baseline } from '../../../styles/grid';

import * as React from 'react';
import { connect } from 'react-redux';

import * as BEM from 'react-bem-helper';
import Button from '../../../atoms/buttons/Button';
import { IconPhone } from '../../../atoms/images/Icon';
import Heading from '../../../atoms/text/Heading';
import { Span } from '../../../atoms/text/Label';

interface IOwnStateProps {
  openingHours: string;
  phoneNumber: GQL.IBusinessPhoneNumber;
  euPhoneNumber: GQL.IBusinessPhoneNumber;
}

type NoMatchFoundProps = IOwnStateProps;

const contactOptionsClasses = new BEM('contact-options');

const NoMatchFoundBase: React.SFC<NoMatchFoundProps> = ({
  openingHours,
  phoneNumber,
  euPhoneNumber,
}) => (
  <>
    <Heading is="h1" textColor="bw6">No Match Found.</Heading>
    <Heading is="h4" textColor="bw7">
      Can't find what you're looking for? We can definitely help!
    </Heading>
    <div {...contactOptionsClasses()}>
      <IconPhone />
      <Heading is="h4">
        {phoneNumber.phone_number} (NA) /&nbsp;
      </Heading>
      <Heading is="h4">
        {euPhoneNumber.phone_number} (EU)
      </Heading>
      <Span size="small" textColor="bw7" style={{ margin: `0 ${baseline * 2}px` }}>or</Span>
      <Button
        label="Chat with our experts "
        size="small"
        onClick={Olark.expand}
        colorScheme="dark"
        variant="pill"
      />
    </div>
    <Span size="small" textColor="bw7" style={{ marginTop: baseline * 2 }} block>
      We're available from Monday to Friday between {openingHours}.
    </Span>
  </>
);

export const NoMatchFound = connect<IOwnStateProps, {}, {}, IStoreState>(
  (state) => ({
    openingHours: getBusinessOpeningHours(state),
    phoneNumber: getBusinessMainPhoneNumber(state),
    euPhoneNumber: getBusinessEuropeanPhoneNumber(state),
  }),
)(NoMatchFoundBase);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/browse/Results/NoMatchFound.tsx